<template>
  <div class="header">
    <slot></slot>
    <Search
      v-if="showSearch"
      @show="showInput"
      @input="search"
      :view="view"
      :showSearchInput="showSearchInput"
      :loggedIn="user"
      :value="value"
    />
    <b-button
      v-if="!user && showLoginBtn"
      class="login-button"
      @click="$emit('clickedLogin')"
      :type="showLoginForm ? 'is-danger' : 'is-ligth'"
      rounded
      >{{ showLoginForm ? "CLOSE" : "LOGIN" }}</b-button
    >
    <b-dropdown
      v-if="user && showLoginBtn"
      position="is-bottom-left"
      :icon-left="'face'"
      class="user-dropdown"
      aria-role="list"
    >
      <b-button
        :title="user.name"
        :class="user.photo ? 'loggedin-button-image' : 'loggedin-button'"
        :icon-left="!user.photo ? 'account' : ''"
        slot="trigger"
      >
        <img class="loggedin-image" v-if="user.photo" :src="user.photo" />
      </b-button>
      <b-dropdown-item @click="goTo('/profile')" aria-role="listitem"
        >Profile</b-dropdown-item
      >
      <b-dropdown-item @click="userLogout" aria-role="listitem"
        >Logout</b-dropdown-item
      >
    </b-dropdown>
    <User v-if="showLoginForm && !user"></User>
  </div>
</template>

<script>
import Search from "../components/header/Search";
import User from "../components/user/Index";
import { getCookieValue } from "../utils/helpers";
import { goTo } from "../mixins/goTo.js";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Header",
  components: {
    Search,
    User
  },
  mixins: [goTo],
  watch: {
    showLogin: "setLoginVisible"
  },
  computed: {
    ...mapGetters(["user"])
  },
  props: {
    showLogin: {
      type: Boolean
    },
    showLoginBtn: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    view: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    showSearchInput: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapMutations(["logout"]),
    userLogout() {
      this.logout();
    },
    search(value) {
      this.$emit("input", value);
    },
    showInput(visible) {
      this.$emit("show", visible);
    },
    setLoginVisible() {
      if (this.showLoginForm && this.showLogin) {
        this.showLoginForm = false;
      } else if (!this.showLoginForm && !this.showLogin) {
        this.showLoginForm = true;
      } else {
        this.showLoginForm = this.showLogin;
      }
    }
  },
  created() {
    this.showLoginForm = this.showLogin;
    let identiyErrorMessage = getCookieValue("identiyErrorMessage");
    if (identiyErrorMessage && identiyErrorMessage !== "") {
      this.showLoginForm = true;
    }
  }
};
</script>
